module.exports = "<div class=\"hp-inner-center salesrep-after-funding-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1>The project has been submitted to HERO for review!</h1>\n\t\t    <p>Your company's admin has submitted the project for funding.</p>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n        <div class=\"col-md-12 walkthrough-next-steps\">\n            <p class=\"header\">Next Steps</p>\n\t\t    <p>Our closers will review this project.</p>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/walkthrough/getPaid/salesRepAfterFundingWalkthroughTemplate.html
// module id = 665
// module chunks = 1